import React, {useCallback, useEffect, useState} from "react";
import {inject, observer} from "mobx-react";
import {orderBy} from "lodash";

import {llattempt} from "../../../common/utils";
import api from "../../../common/api";

import {LLPreloader} from "../index";
import {RulesArticle} from "./components/rules-article";
import {RulesMenu} from "./components/rules-menu";


export const Rules = inject('store')(observer((
    {
        store,
        type = 'general_rules',
        articleId = null,
    }
) => {
    const viewSize = store.site.status.viewSize;

    const
        [isMenuLoading, setMenuLoading] = useState(true),
        [menuItems, setMenuItems] = useState(null),
        [activeArticleId, setActiveArticleId] = useState(articleId);

    const structureMenu = useCallback((menuData) => {
        const map = new Map();
        menuData = orderBy(menuData, ['sort', 'title'], ['asc', 'asc']);
        menuData.forEach((item) => {
            map.set(item.id, { ...item, children: new Map() });
        });
        menuData.forEach((item) => {
            if (item.ParentID !== 0) {
                const parentItem = map.get(item.ParentID);
                if (parentItem) {
                    parentItem.children.set(item.id, map.get(item.id));
                }
            }
        });
        const filteredItems = [...map.values()]
            .filter((item) => item.ParentID === 0);
        const res = new Map();
        filteredItems.forEach(item =>  res.set(item.id, { ...item }));
        return res;
    }, []);

    const loadHelpMenu = useCallback(() => {
        setMenuLoading(true);
        return llattempt(() =>
            api.user.getHelpMenu().then((res) => {
                if (!res.success) {
                    throw new Error();
                } else {
                    return res;
                }
            }),
            {
                msg: 'Error loading help menu',
                at: 'Rules.loadHelpMenu',
                onError: () => {
                    setMenuLoading(false);
                },
                withNotifier: true,
            });
    }, []);

    useEffect(() => {
        loadHelpMenu().then((res) => {
            if (res && res.data) {
                setMenuItems(structureMenu(res.data));
                // When an explicit articleId is provided we show it directly and
                // skip the slug->menu-item resolution (article needs no menu link).
                if (!articleId) {
                    const articleByType = res.data.find(item => item.slug === type);
                    if (articleByType?.article_id) {
                        setActiveArticleId(articleByType.article_id);
                    } else {
                        // TODO: setError here
                    }
                }
            } else {
            // TODO: setError here
            }
            setMenuLoading(false);
        });
    }, [loadHelpMenu, setMenuItems, type, articleId]);

    return (
        <div
            className={`rules__content-wrapper ${
                viewSize === 'desktop'
                    ? 'rules__content-wrapper--desktop'
                    : 'rules__content-wrapper--mobile'
            }`}
        >
            { isMenuLoading ?
                <div className="rules__loader-box">
                    <LLPreloader />
                </div>
                :
                <>
                    <RulesMenu
                        {...{
                            menuItems,
                            activeArticleId,
                            setActiveArticleId,
                        }}
                        viewSize={viewSize}
                    />
                    <RulesArticle
                        activeArticleId={activeArticleId}
                        setActiveArticleId={setActiveArticleId}
                    />
                </>
            }
        </div>
    );
}));